import { Alert, Skeleton } from "antd"
import { useRainforestMerchantOnboardingSessionQuery } from "../../../domain/invoicing/rainforestQueries"
import MerchantOnboarding from "../../Rainforest/MerchantOnboarding"
import { MerchantStatusData } from "../../../domain/invoicing/rainforest"
import { useContext } from "react"
import { AuthenticationContext } from "../../../AuthenticationContext"
import VSpace from "../../common/VSpace"

type Props = {
  merchantStatusData: MerchantStatusData
  onApplicationSubmitted: () => void
}

const MerchantApplicationForm = ({merchantStatusData, onApplicationSubmitted}: Props) => {
  const merchantOnboardingSessionQuery = useRainforestMerchantOnboardingSessionQuery()
  const { currentUser } = useContext(AuthenticationContext)
  const isSuperUser = currentUser?.isSuperUser === true

  if (merchantOnboardingSessionQuery.isLoading) {
    return <section><Skeleton /></section>
  }

  if (merchantOnboardingSessionQuery.isError || !merchantOnboardingSessionQuery.data?.sessionKey) {
    return <section><Alert message="Unable to access the application at this time." type="error" /></section>
  }

  return <VSpace>
    <MerchantOnboarding
      merchantStatusData={merchantStatusData}
      rainforestSession={merchantOnboardingSessionQuery.data}
      onSubmitted={onApplicationSubmitted}
    />
    {isSuperUser && <Alert type="warning" description={<VSpace>
      <strong>Super User Notes for Sandbox Applications:</strong>
      <ul>
        <li>
          Tax ID and SSN cannot be 1234567890 nor a single digit repeated (<a href="https://docs.rainforestpay.com/docs/onboarding-merchants-via-component#sandbox" target="_blank">see docs</a>)
        </li>
        <li>
          You can use 091000022 as the bank routing number (<a href="https://docs.rainforestpay.com/docs/test-accounts-and-cards" target="_blank">see docs</a>)
        </li>
      </ul>
      </VSpace>
    } />}
  </VSpace>
}

export default MerchantApplicationForm